<div style="text-align: center; min-width: 300px">
  <div mat-dialog-content>
    <lemon-dialog-header> Lopeta asiakkaan työkielto </lemon-dialog-header>
    <div style="margin-top: 1rem; margin-bottom: 1rem">Asiakkaan yhteyshenkilölle ja kirjanpitäjille lähetetään sähköposti, jossa kerrotaan työkiellon loppumisesta.</div>
  </div>

  <div mat-dialog-actions style="padding-left: 0; padding-right: 0; gap: 0.25rem">
    <app-primary-button actionId="Peruuta ja sulje dialog" [focusRegionStart]="true" mat-dialog-close>Peruuta</app-primary-button>
    <app-secondary-button (click)="tallenna()" actionId="Lopeta työkielto">Lopeta työkielto</app-secondary-button>
  </div>
</div>
